import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const ChecklistCheckItemDueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChecklistCheckItemDue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checklist"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"waitOn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"None"}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"EnumValue","value":"due"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"ChecklistCheckItemDue","document":ChecklistCheckItemDueDocument}} as const;
export type ChecklistCheckItemDueQueryVariables = Types.Exact<{
  parentId: Types.Scalars['ID'];
}>;


export type ChecklistCheckItemDueQuery = (
  { __typename: 'Query' }
  & { checklist?: Types.Maybe<(
    { __typename: 'Checklist' }
    & Pick<Types.Checklist, 'id'>
    & { checkItems: Array<(
      { __typename: 'CheckItem' }
      & Pick<Types.CheckItem, 'id'>
    )> }
  )> }
);




/**
 * __useChecklistCheckItemDueQuery__
 *
 * To run a query within a React component, call `useChecklistCheckItemDueQuery` and pass it any options that fit your needs.
 * When your component renders, `useChecklistCheckItemDueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChecklistCheckItemDueQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useChecklistCheckItemDueQuery(baseOptions: Apollo.QueryHookOptions<ChecklistCheckItemDueQuery, ChecklistCheckItemDueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChecklistCheckItemDueQuery, ChecklistCheckItemDueQueryVariables>(ChecklistCheckItemDueDocument, options);
      }
export function useChecklistCheckItemDueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChecklistCheckItemDueQuery, ChecklistCheckItemDueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChecklistCheckItemDueQuery, ChecklistCheckItemDueQueryVariables>(ChecklistCheckItemDueDocument, options);
        }
export type ChecklistCheckItemDueQueryHookResult = ReturnType<typeof useChecklistCheckItemDueQuery>;
export type ChecklistCheckItemDueLazyQueryHookResult = ReturnType<typeof useChecklistCheckItemDueLazyQuery>;
export type ChecklistCheckItemDueQueryResult = Apollo.QueryResult<ChecklistCheckItemDueQuery, ChecklistCheckItemDueQueryVariables>;